import React from "react";
import photo1 from "./img/Mr_Pramod_Photo.png";
import photo2 from "./img/Miss_Priya_Photo.png";
import photo3 from "./img/Mr_Ganesh_Photo.png";
import photo4 from "./img/Mr_Pankaj_Photo.png";





const teamData = [
  { id: 1, img: photo1, name: "Mr.Pramod Neel", role: "Director and Founder" },
  { id: 2, img: photo2, name: "Miss.Priya Gaikwad", role: "HR Manager" },
  { id: 3, img: photo3, name: "Mr.Ganesh Katkar", role: "Application Developer" },
  { id: 4, img: photo4, name: "Mr.Pankaj Agale", role: "Software Developer" },
];

function Team() {
  return (
    <div className="team">
      <div className="container-fluid">

        {/* Header */}
        <div class="page-header">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <h2>Our Team</h2>

                            <h5 style={{'color':'white'}}>“Meet our team of skilled professionals dedicated to delivering innovative IT solutions.”</h5>
                        </div>
                       
                    </div>
                </div>
            </div>
        

        {/* Team Members */}
        <div className="row">
          {teamData.map((member) => (
            <div key={member.id} className="col-sm-6 col-lg-3">
              <div className="team-item">

                <div className="team-img">
                  <img src={member.img} alt="Team" height="250px" />
                </div>

                <div className="team-text">
                  <h3>{member.name}</h3>
                  <p>{member.role}</p>
                </div>

                <div className="team-social">
                  <a href="#"><i className="fab fa-facebook-f"></i></a>
                  <a href="#"><i className="fab fa-twitter"></i></a>
                  <a href="#"><i className="fab fa-linkedin-in"></i></a>
                  <a href="#"><i className="fab fa-pinterest"></i></a>
                  <a href="#"><i className="fab fa-youtube"></i></a>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default Team;